import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, map } from 'rxjs';
 
@Injectable({ providedIn: 'root' })
export class InternetService {
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);
  onlineStatus$ = this.onlineStatus.asObservable();
 
  constructor() {
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).subscribe(status => {
      this.onlineStatus.next(status);
    });
  }
}